import { DashboardLayout } from "../../components/dashboard";
import { ROUTE_LEARNING_ASSETS } from "../../route";
import useHandler from "./handler";

export const Dashboard = () => {
  const { user, dashboardData, loading } = useHandler();

  return (
    <DashboardLayout
      aiAssets={ROUTE_LEARNING_ASSETS}
      user={user}
      dashboardData={dashboardData}
      loading={loading}
      videoLimit={2}
    />
  );
};
